// @flow
import React from 'react';
// When react-router-dom is updated, prefer useHistory instead.
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import MobileDownloadButton from './MobileDownloadButton';

import { isMobile, getOS } from '../../utils';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  heading: {
    marginBottom: 20,
  },
  button: {
    width: '100%',
    minWidth: 210,
    backgroundColor: theme.palette.ava.blue,
    color: theme.palette.ava.white,
  },
  buttonContained: {
    '&:hover': {
      backgroundColor: theme.palette.ava.blue,
    },
  },
  buttonLabel: {
    display: 'flex',
    flexDirection: 'column',
  },
  buttonMainText: {
    fontSize: 20,
    fontWeight: 600,
  },
  buttonSubText: {
    marginTop: -10,
    fontSize: 16,
    opacity: 0.8,
  },
}));

interface Props {
  userExists: boolean;
  hostName: string;
  onClick: Function;
  history: Object;
}

const RatingExcellent = ({ userExists, hostName, onClick, history }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const OS = getOS();
  const mobile = isMobile();

  return (
    <div className={classes.content}>
      {userExists && !mobile && !window.isElectron && (
        <>
          <Typography className={classes.heading} variant="h5">
            {t('conversation.over.doYouWantSomeMore')}
          </Typography>

          <Button
            key="download_convo_btn"
            classes={{
              root: classes.button,
              contained: classes.buttonContained,
              label: classes.buttonLabel,
            }}
            variant="contained"
            onClick={onClick}
          >
            <span className={classes.buttonMainText}>{t('conversation.over.openAva', { OS })}</span>
            <span className={classes.buttonSubText}>{t('conversation.over.forAMagicalExperience')}</span>
          </Button>
        </>
      )}

      {userExists && mobile && (
        <>
          <Typography className={classes.heading} variant="h5">
            {t('conversation.over.doYouWantSomeMore')}
          </Typography>

          {isMobile() ? (
            <MobileDownloadButton />
          ) : (
            <Button
              key="download_convo_btn"
              classes={{
                root: classes.button,
                contained: classes.buttonContained,
                label: classes.buttonLabel,
              }}
              variant="contained"
              onClick={onClick}
            >
              <span className={classes.buttonMainText}>{t('conversation.over.getAva')}</span>
              <span className={classes.buttonSubText}>{t('conversation.over.forAMagicalExperience')}</span>
            </Button>
          )}
        </>
      )}

      {!userExists && mobile && (
        <>
          <Typography className={classes.heading} variant="h5">
            {t('conversation.over.planOnSpeakWith')} {hostName} {t('conversation.over.again?')}
          </Typography>

          {isMobile() ? (
            <MobileDownloadButton />
          ) : (
            <Button
              key="download_convo_btn"
              classes={{
                root: classes.button,
                contained: classes.buttonContained,
                label: classes.buttonLabel,
              }}
              variant="contained"
              onClick={onClick}
            >
              <span className={classes.buttonMainText}>{t('conversation.over.downloadAvaApp')}</span>
              <span className={classes.buttonSubText}>{t('conversation.over.forAMagicalExperience')}</span>
            </Button>
          )}
        </>
      )}

      {!userExists && !mobile && (
        <>
          <Typography className={classes.heading} variant="h5">
            {t('conversation.over.planOnSpeakWith')} {hostName} {t('conversation.over.again?')}
          </Typography>

          <Button
            key="download_convo_btn"
            classes={{
              root: classes.button,
              contained: classes.buttonContained,
              label: classes.buttonLabel,
            }}
            variant="contained"
            onClick={() => {
              setTimeout(() => history.push('/web/login'), 300);
            }}
          >
            <span className={classes.buttonMainText}>{t('conversation.over.transcribeYourOwnMeetings')}</span>
          </Button>
        </>
      )}
    </div>
  );
};

export default withRouter(RatingExcellent);
